import QRCode from "react-qr-code";
import styled from "styled-components";
import html2canvas from "html2canvas";
import logo from "../../../assets/img/CuronextFinal.png";
import { FiDownload } from "react-icons/fi";
// Styled components
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Card = styled.div`
  width: 100%;
  max-width: 400px;
  background-color: rgba(255, 255, 255, 0.50);
  border-radius: 12px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  padding: 24px;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 20px;
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 8px;
`;

const Subtitle = styled.p`
  color: #4b5563;
  margin-bottom: 24px;
`;

const QRCodeContainer = styled.div`
  width: 200px;
  height: 200px;
  margin: 0 auto 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  padding: 8px;
  border-radius: 8px;
`;

const PassCode = styled.div`
  background-color: #3b82f6;
  color: white;
  font-weight: bold;
  padding: 4px 24px;
  border-radius: 9999px;
  display: inline-block;
  margin-bottom: 16px;
`;

const DateInfo = styled.div`
  color: #1f2937;
  margin-bottom: 8px;
  line-height: 1.5;
`;

const LocationInfo = styled.div`
  color: #1f2937;
  margin-bottom: 24px;
  line-height: 1.5;
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const Logo = styled.img`
  width: 160px;
  filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.5));
  transition: transform 0.4s ease;
  &:hover {
    transform: rotate(5deg) scale(1.15);
  }
`;

const DownloadButton = styled.button`
     background-color: #3b82f6;
    color: white;
    font-weight: bold;
    padding: 8px 16px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    margin-bottom: 16px;
    transition: background-color 0.3s ease;
    position: absolute;
    top: 30px;
    right: 0;
`;

// StyledComponentsRegistry for Next.js compatibility
const StyledComponentsRegistry = ({ children }) => {
  return children;
};

export default function InvitationScreen({ Qrdata, data }) {
  const { visitorQRCodeString } = Qrdata ?? {};
  const { visitStartDt, visitEndDt, towerName, flatName, buildingName, city, state, pinCode,createdUserName } = data ?? {};
  console.log(data, visitorQRCodeString, "Data");

  // Function to handle download
  const handleDownload = () => {
    const cardElement = document.querySelector("#invitation-card");
    html2canvas(cardElement).then((canvas) => {
      const link = document.createElement("a");
      link.download = "invitation-card.png";
      link.href = canvas.toDataURL("image/png");
      link.click();
    });
  };

  function convertDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    const monthName = date.toLocaleString("default", { month: "short" }).toLowerCase();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return (
      <span>
        {`${day}-${monthName}-${year} `}
        {` ${hours}:${minutes}`}
      </span>
    );
  }

  return (
    <StyledComponentsRegistry>
      <Container>
        <DownloadButton onClick={handleDownload}>
          <FiDownload size={18} /> {/* Download icon */}
        </DownloadButton>
        <Card id="invitation-card">
          {/* Download Button at the top */}


          <Title>{createdUserName} has invited you.</Title>
          <Subtitle>Show QR or Pass code to the security at the gate for hassle free entry</Subtitle>

          <QRCodeContainer>
            {Qrdata && (
              <QRCode
                value={Qrdata}
                size={180}
                level="H"
              />
            )}
          </QRCodeContainer>

          <PassCode>{Qrdata}</PassCode>

          <DateInfo>
            {convertDate(visitStartDt)} to
            <br />
            {convertDate(visitEndDt)}
          </DateInfo>

          <LocationInfo>
            {towerName && towerName} - {flatName && flatName + ","} {buildingName && buildingName}
            <br />
            {state}
            <br />
            {city && city} {city && "-"} {pinCode && pinCode}
          </LocationInfo>

          <LogoContainer>
            <Logo src={logo} alt="Event Logo" />
          </LogoContainer>
        </Card>
      </Container>
    </StyledComponentsRegistry>
  );
}